import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTheme } from '@material-ui/core'
import AppContext from 'components/app/AppContext'
import D3TopicSelector from './D3TopicSelector'

// let vis: D3TopicSelector | null = null

interface TopicSelectorWidgetProps {
    onSelectTopic: (topicId: number) => void
}

const TopicSelectorWidget: React.FC<TopicSelectorWidgetProps> = (props) => {
    const theme = useTheme()
    const appContext = useContext(AppContext)
    const [vis, setVis] = useState<D3TopicSelector | null>(null)
    const [width, setWidth] = useState(800)
    const [height, setHeight] = useState(800)
    const refElement = useRef(null)
    const refParentElement = useRef<HTMLDivElement | null>(null)
    const { onSelectTopic } = props
    
    useEffect(() => {
        let resizeTimer: NodeJS.Timeout
        const setSize = () => {
            const parent = refParentElement.current
            if (parent != null) {
                // console.log("Size", window.innerWidth, window.innerHeight, parent.offsetWidth, parent.offsetHeight)
                setWidth(parent.offsetWidth)
                setHeight(parent.offsetHeight || window.innerHeight)
            }
        }

        const handleResize = () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(function () {
                setSize()
            }, 100)
        }

        window.addEventListener('resize', handleResize)
        setSize()

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (appContext.topics.length > 0 && vis == null) {
            const d3Props = {
                topics: appContext.topics,
                width,
                height,
                colorPrimary: theme.palette.primary.main,
                colorBackground: theme.palette.common.white,
                colorText: theme.palette.text.primary,
                onSelectTopic: onSelectTopic
            }
            
            setVis(new D3TopicSelector(refElement.current!!, d3Props))
        }
    }, [appContext.topics, vis, width, height, theme.palette.primary.main, theme.palette.common.white, theme.palette.text.primary, onSelectTopic])

    useEffect(() => {
        if (vis && width > 0 && height > 0) {
            vis.resize(width, height)
        }
    }, [vis, width, height])

    return (
        <div ref={refParentElement}>
            <div ref={refElement} />
        </div>
    )
}

export default TopicSelectorWidget
